export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-alert-7a789611887c658f7c6083eaf2778a9c.svg";